import { DatePipe } from '@angular/common';
import {
    AfterViewInit,
    Component,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import { EntityCollectionService, EntityServices } from '@ngrx/data';
import { select, Store } from '@ngrx/store';
import clone from 'just-clone';
import moment from 'moment';
import { Observable, Subscription } from 'rxjs';
import { debounceTime, filter, map, takeWhile, withLatestFrom } from 'rxjs/operators';
import * as fromSettings from '../../company-setting';
import { CompanySetting } from '../../company-setting';
import * as fromDataServices from '../../data-services';
import { SignaturePolicy } from '../../data-services/signature-policy';
import * as fromLookups from '../../lookups';
import * as fromShared from '../../shared';
import { Process } from '../../shared';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { IUserInfo } from '../../user-info';
import { IUserColor } from '../../user-info/IUserColor';
import * as fromUser from '../../user-info/store';
import { IDirectReportsWithTimeStatus } from '../IDirectReportsWithTimeStatus';
import { ITimeCard } from '../itime-card';
import { IWeeklySummary } from '../IWeeklySummary';
import * as fromTimecard from '../store';
import * as fromDRWTS from '../store/direct-reports-with-time-status.actions';
import * as fromdrwtsR from '../store/direct-reports-with-time-status.reducer';
import * as fromAuthorizedTask from '../store/iauthorized-task.actions';
import * as fromAuthorizedTaskR from '../store/iauthorized-task.reducer';
import * as fromManagement from '../store/management-action.actions';
import * as fromTimeCardSubmit from '../store/time-card-submit.actions';
import * as fromTimeCardSubmitR from '../store/time-card-submit.reducer';
import * as selectors from '../store/time-card.selectors';
import * as fromWeeklySummary from '../store/weekly-summary.actions';
import * as fromWeeklySummaryR from '../store/weekly-summary.reducer';
import { TimeCardPresenterComponent } from '../time-card-presenter';
import { TimeCardService } from '../time-card.service';
import * as fromTaskTimer from '../../task-timer/store/task-timer.actions'
import * as fromTaskTimerR from '../../task-timer/store/task-timer.reducer'
import { TaskTimer } from '../../data-services/task-timer/task-timer.model';
import { IManagementAction } from '../IManagementAction';
import { ManagementActionService } from '../managementActionService';
@Component({
    selector: 'ef-time-card-feature',
    templateUrl: './time-card-feature.component.html',
    styleUrls: ['./time-card-feature.component.scss'],
    standalone: false
})
export class TimeCardFeatureComponent
    implements OnInit, AfterViewInit, OnDestroy
{
    public userInfo$: Observable<IUserInfo>;
    public process$: Observable<Process>;
    @ViewChild(TimeCardPresenterComponent, { static: true })
    tcpc: TimeCardPresenterComponent;
    public timecards$: Observable<Array<ITimeCard>>;
    public companySettings$: Observable<Array<CompanySetting>>;
    public userWebColors$: Observable<Array<IUserColor>>;
    // public authorizedTasks$: Observable<Array<IAuthorizedTask>>;
    public weeklySummaryData$: Observable<Array<IWeeklySummary>>;
    public signaturePolicy$: Observable<SignaturePolicy[]>;
    public directReportTimeStatusData$: Observable<
        Array<IDirectReportsWithTimeStatus>
    >;
    public directReports$: Observable<Array<fromLookups.IDirectReport>>;
    private active = true;
    userInfo: IUserInfo;
    public employeeListID = '';
    public employeeName = '';
    public userEntryStartDate: Date;
    public userEntryEndDate: Date;
    public RoleID: number;
    timeCardDateFromNextOrPrev: string;
    directionFromNextOrPrev: string;
    @Input() public process: Process;
    p: Process;
    signaturePolicyDataService: EntityCollectionService<fromDataServices.SignaturePolicy.SignaturePolicy>;
    timecardSequenceDataService: EntityCollectionService<fromDataServices.TimecardSequence.TimecardSequence>;
    public timecardSequence$: Observable<
        Array<fromDataServices.TimecardSequence.TimecardSequence>
    >;
    taskTimer$: Observable<TaskTimer[]>;

    IsLoading = false;
    timerActive = false;
    timerMessage = 'A timer is currently active. Stop the timer to enter time via TimeCard';

    managementActionResponse$: Observable<any>;

    constructor(
        @Inject(LoggingService) private log: LoggingService,
        private store: Store<fromTimecard.State>,
        private tcSubmitStore: Store<fromTimeCardSubmitR.State>,
        private aTstore: Store<fromAuthorizedTaskR.State>,
        private wSstore: Store<fromWeeklySummaryR.State>,
        private dRstore: Store<fromdrwtsR.State>,
        private lookupsStore: Store<fromLookups.LookupState>,
        private datePipe: DatePipe,
        public timeCardService: TimeCardService,
        public entityServices: EntityServices,
        private managementActionService: ManagementActionService
    ) {
        this.signaturePolicyDataService =
            entityServices.getEntityCollectionService<fromDataServices.SignaturePolicy.SignaturePolicy>(
                fromDataServices.SignaturePolicy.entityName
            );
        this.timecardSequenceDataService =
            entityServices.getEntityCollectionService<fromDataServices.TimecardSequence.TimecardSequence>(
                fromDataServices.TimecardSequence.entityName
            );
    }

    transformDate(date): Date {
        return new Date(this.datePipe.transform(date, 'MM/dd/yyyy'));
    }

    ngOnInit() {
        this.timeCardDateFromNextOrPrev = null;
        this.directionFromNextOrPrev = null;
        this.store.dispatch(fromTaskTimer.getTaskTimer());
        // this.store.dispatch(new fromUser.LoadUserInfo());
        this.store.dispatch(
            fromSettings.getCompanySetting({ SettingType: 'require_signature' })
        );
        this.store.dispatch(
            fromSettings.getCompanySetting({ SettingType: 'RequireTimeSubmit' })
        );
        this.store.dispatch(
            fromSettings.getCompanySetting({ SettingType: 'reqValidation' })
        );
        this.store.dispatch(
            fromSettings.getCompanySetting({ SettingType: 'TCIncludeClassify' })
        );
        this.store.dispatch(
            fromSettings.getCompanySetting({ SettingType: 'time_precision' })
        );
        this.store.dispatch(
            fromSettings.getCompanySetting({
                SettingType: 'ShowAvailableHours'
            })
        );
        this.store.dispatch(
            fromSettings.getCompanySetting({
                SettingType: 'ShowAccrualsOnTimeCard'
            })
        );
        this.directReports$ = this.lookupsStore.pipe(
            select(fromLookups.getDirectReportsLookup)
        );

        // this.authorizedTasks$ = this.aTstore.pipe(
        //     select(fromAuthorizedTaskR.selectAll)
        // );

        this.weeklySummaryData$ = this.wSstore.pipe(
            select(fromWeeklySummaryR.selectAll)
        );

        this.timecards$ = this.store.pipe(
            select(selectors.selectAll),
            map(items => clone(items))
        );

        this.userWebColors$ = this.store.pipe(
            select(fromUser.getUserColorsSorted)
        );
        this.directReportTimeStatusData$ = this.dRstore.pipe(
            select(fromdrwtsR.selectAll)
            // filter(items => !!items && items.length > 0),
        );
        this.signaturePolicy$ = this.signaturePolicyDataService.entities$;
        this.timecardSequence$ =
            this.timecardSequenceDataService.entities$.pipe(debounceTime(500));
        this.companySettings$ = this.store.pipe(select(fromSettings.selectAll));

        this.setupSubscriptions();
    }
    ngAfterViewInit(): void {}
    setupSubscriptions() {
        // this.directReportTimeStatusData$
        //     .pipe(takeWhile(() => this.active))
        //     .subscribe(drwts => {
        //         if (drwts.length >= 0) {
        //             this.IsLoading = false;
        //         } else {
        //             this.IsLoading = true;
        //         }
        //     });

        this.managementActionResponse$ = this.managementActionService.managementActionResp$;
        
        this.process$ = this.store.pipe(select(fromShared.selectCurrent));

        this.taskTimer$ = this.store.pipe(
            select(fromTaskTimerR.selectAll),
            map(x => clone(x))
        );

        this.userInfo$ = this.store.pipe(select(fromUser.getUserInfo));

        this.process$
            .pipe(
                takeWhile(() => this.active),
                filter(process => !!process),
                withLatestFrom(this.userInfo$)
            )
            .subscribe(([process, userInfo]) => {
                this.log.verbose({
                    type: 'TimeCardFeatureComponent:process$',
                    process
                });
                switch (process.ProcessID) {
                    case 87:
                        // Task Manager
                        break;
                    case 85:
                        // Supervisor
                        break;
                    case 90:
                        // Super User
                        break;
                    case 64:
                        // User
                        if (userInfo) {
                            const todaysDate = new Date();
                            const timeCardDate = todaysDate;
                            if (this.timeCardDateFromNextOrPrev != null) {
                                this.store.dispatch(
                                    fromTimecard.getTimeCards({
                                        EmployeeListID: userInfo.EmployeeListID,
                                        TimeCardDate: moment(
                                            this.timeCardDateFromNextOrPrev
                                        ).format('MM/DD/YYYY'),
                                        MyDirection:
                                            this.directionFromNextOrPrev,
                                        MinEntryDate:
                                            userInfo.UserEntryStartDate
                                    })
                                );
                            } else {
                                this.store.dispatch(
                                    fromTimecard.getTimeCards({
                                        EmployeeListID: userInfo.EmployeeListID,
                                        TimeCardDate:
                                            moment(timeCardDate).format(
                                                'MM/DD/YYYY'
                                            ),
                                        MyDirection: null,
                                        MinEntryDate:
                                            userInfo.UserEntryStartDate
                                    })
                                );
                            }

                            this.wSstore.dispatch(
                                fromWeeklySummary.getWeeklySummary({
                                    EmployeeListID: userInfo.EmployeeListID
                                })
                            );
                        }

                        break;
                    default:
                        console.log('Not a timecard process');
                        break;
                }
            });

        this.userInfo$
            .pipe(
                takeWhile(_ => this.active),
                withLatestFrom(this.process$)
            )
            .subscribe(([userInfo, process]) => {
                this.log.verbose({
                    type: 'TimeCardFeatureComponent:setupSubscriptions:userInfo$',
                    userInfo
                });
                this.userInfo = userInfo;
                this.employeeListID = userInfo.EmployeeListID;
                this.employeeName = userInfo.EmployeeName;
                this.userEntryStartDate = userInfo.UserEntryStartDate;
                this.userEntryEndDate = userInfo.UserEntryEndDate;
                this.RoleID = userInfo.RoleGroupID;

                if (
                    process.ProcessID == 85 ||
                    process.ProcessID == 87 ||
                    process.ProcessID == 90
                ) {
                    this.store.dispatch(
                        fromSettings.getCompanySetting({
                            SettingType: 'LockTimeCardsForSupervisor'
                        })
                    );
                    this.store.dispatch(
                        new fromLookups.LoadDirectReports({
                            user: userInfo,
                            activeOnly: false
                        })
                    );
                }
            });

        this.taskTimer$.pipe(
                takeWhile(() => this.active),
                withLatestFrom(this.process$)
                ).subscribe(([timer, process]) => {
                    const timerList = timer.filter(x => x.stoptime == null);
                    switch (process.ProcessID) {
                        case 87:
                            // Task Manager
                            break;
                        case 85:
                            // Supervisor
                            break;
                        case 90:
                            // Super User
                            break;
                        default:
                            // User
                            if (timerList.some(x => x.starttime != null) == true) {
                                this.timerActive = true;
                            } else {
                                this.timerActive = false;
                            }
                            break;
                    }
            });

        this.tcpc.refreshStatusEE
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    this.store.dispatch(
                        fromTimecard.getTimeCards({
                            EmployeeListID: value.empListID,
                            TimeCardDate: moment(value.date).format(
                                'MM/DD/YYYY'
                            ),
                            MyDirection: null,
                            MinEntryDate: this.userInfo.UserEntryStartDate
                        })
                    );
                }
            });

        this.tcpc.nextOrPrevious
            .pipe(
                takeWhile(_ => this.active),
                withLatestFrom(this.process$)
            )
            .subscribe(([value, process]) => {
                if (value != null) {
                    // var timeCardDate = this.transformDate(value.date);
                    this.timeCardDateFromNextOrPrev = value.date;
                    this.directionFromNextOrPrev = value.direction;
                    if (
                        process.ProcessID == 87 ||
                        process.ProcessID == 85 ||
                        process.ProcessID == 90
                    ) {
                        this.store.dispatch(
                            fromTimecard.getTimeCards({
                                EmployeeListID: value.empListID,
                                TimeCardDate: moment(value.date).format(
                                    'MM/DD/YYYY'
                                ),
                                MyDirection: value.direction,
                                Processid: process.ProcessID,
                                MinEntryDate: this.userInfo.UserEntryStartDate,
                                EndDate: value.endDate
                            })
                        );
                    } else {
                        this.store.dispatch(
                            fromTimecard.getTimeCards({
                                EmployeeListID: value.empListID,
                                TimeCardDate: moment(value.date).format(
                                    'MM/DD/YYYY'
                                ),
                                MyDirection: value.direction,
                                MinEntryDate: this.userInfo.UserEntryStartDate
                            })
                        );
                    }
                }
            });

        this.tcpc.updateTasks
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                this.aTstore.dispatch(
                    fromAuthorizedTask.getAuthorizedTasks({
                        EmployeeListID: value.EmployeeListID,
                        AuthType: 'Time',
                        AsOfDate: null
                    })
                );
            });

        this.tcpc.tcSubmit
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    this.tcSubmitStore.dispatch(
                        fromTimeCardSubmit.putTimeCardSubmit({
                            timeCardSubmit: value
                        })
                    );
                }
            });

        this.tcpc.supervisorDRSelected
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    this.wSstore.dispatch(
                        fromWeeklySummary.getWeeklySummary({
                            EmployeeListID: value.EmployeeListID
                        })
                    );
                    this.store.dispatch(
                        fromTimecard.getTimeCards({
                            EmployeeListID: value.EmployeeListID,
                            TimeCardDate: value.TimeCardDate,
                            MyDirection: null,
                            MinEntryDate: this.userInfo.UserEntryStartDate
                        })
                    );
                }
            });

        this.tcpc.dRSelectedSubject
            .pipe(
                takeWhile(_ => this.active),
                withLatestFrom(this.process$)
            )
            .subscribe(([value, process]) => {
                if (value != null) {
                    const todaysDate = new Date();
                    const timeCardDate = todaysDate;
                    if (process.ProcessID == 87 || process.ProcessID == 85) {
                        this.wSstore.dispatch(
                            fromWeeklySummary.getWeeklySummary({
                                EmployeeListID: this.userInfo.EmployeeListID,
                                DRListID: value.EmployeeListID,
                                StartDate: value.ImpactedStart,
                                EndDate: value.ImpactedEnd
                            })
                        );
                        this.store.dispatch(
                            fromTimecard.getTimeCards({
                                EmployeeListID: value.EmployeeListID,
                                TimeCardDate: moment(
                                    value.ImpactedStart
                                ).format('MM/DD/YYYY'),
                                MyDirection: null,
                                Processid: this.process.ProcessID,
                                MinEntryDate: this.userInfo.UserEntryStartDate,
                                EndDate: value.ImpactedEnd
                            })
                        );
                    } else {
                        this.wSstore.dispatch(
                            fromWeeklySummary.getWeeklySummary({
                                EmployeeListID: value.EmployeeListID
                            })
                        );
                        this.store.dispatch(
                            fromTimecard.getTimeCards({
                                EmployeeListID: value.EmployeeListID,
                                TimeCardDate:
                                    moment(timeCardDate).format('MM/DD/YYYY'),
                                MyDirection: null,
                                MinEntryDate: this.userInfo.UserEntryStartDate
                            })
                        );
                    }
                }
            });

        this.tcpc.timeCardUpdate
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null && value.length > 0) {
                    value.forEach(tc => { tc.CurrentUserListID = this.employeeListID; });
                    this.store.dispatch(
                        fromTimecard.putTimeCards({
                            timeCard: value,
                            requireTimeSubmit: this.userInfo?.Requiretimesubmit
                        })
                    );
                }
            });

        this.tcpc.managementUpdate
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    this.dRstore.dispatch(
                        fromManagement.putManagment({ managementAction: value })
                    );
                    // this.wSstore.dispatch(
                    //     fromWeeklySummary.getWeeklySummary({
                    //         EmployeeListID: value.EmployeeListID,
                    //         StartDate: moment(value.MgmtDateRangeStart).toDate(),
                    //         EndDate: moment(value.MgmtDateRangeEnd).toDate()
                    //     })
                    // );
                }
            });

        this.tcpc.actionDateSelected
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    this.dRstore.dispatch(
                        fromDRWTS.getDirectReportsWithTimeStatus({
                            UserListID: this.employeeListID,
                            UserRole: value.Role,
                            StartDate: moment(value.StartDate).format(
                                'MM/DD/YYYY'
                            ),
                            EndDate: moment(value.EndDate).format('MM/DD/YYYY'),
                            MyDRsOnly: value.MyDRsOnly
                        })
                    );
                    this.directReportTimeStatusData$ = this.dRstore.pipe(
                        select(fromdrwtsR.selectAll)
                    );
                }
            });
    }
    onLoadDirectReportsWithTimeStatus($event) {
        switch (this.process.ProcessID) {
            case 87:
                // Task Manager
                this.dRstore.dispatch(
                    fromDRWTS.getDirectReportsWithTimeStatus({
                        UserListID: this.employeeListID,
                        UserRole: 12025,
                        StartDate: $event.startDate ? $event.startDate : null,
                        EndDate: $event.endDate ? $event.endDate : moment(new Date()).format('MM/DD/YYYY'),
                        MyDRsOnly: $event.MyDRsOnly
                    })
                );
                break;
            case 85:
                // Supervisor
                this.dRstore.dispatch(
                    fromDRWTS.getDirectReportsWithTimeStatus({
                        UserListID: this.employeeListID,
                        UserRole: 12024,
                        StartDate: $event.startDate ? $event.startDate : null,
                        EndDate: $event.endDate ? $event.endDate : moment(new Date()).format('MM/DD/YYYY'),
                        MyDRsOnly: $event.MyDRsOnly
                    })
                );
                break;
        }
    }
    onLoadSignaturePolicy($event) {
        this.signaturePolicyDataService.getByKey($event);
    }
    onLoadTimecardSequence($event) {
        this.timecardSequenceDataService.clearCache();
        this.timecardSequenceDataService.getAll();
    }
    onSaveTimecardSequence($event) {
        this.timecardSequenceDataService.upsert($event);
    }
    onMgmtLoadTimecardandWeeklySummary($event) {
        this.wSstore.dispatch(
            fromWeeklySummary.getWeeklySummary({
                EmployeeListID: this.userInfo.EmployeeListID,
                DRListID: $event.EmployeeListID,
                StartDate: $event.StartDate,
                EndDate: $event.EndDate
            })
        );
        this.store.dispatch(
            fromTimecard.getTimeCards({
                EmployeeListID: $event.EmployeeListID,
                TimeCardDate: $event.StartDate,
                MyDirection: null,
                Processid: this.process.ProcessID,
                MinEntryDate: this.userInfo.UserEntryStartDate,
                EndDate: $event.EndDate
            })
        );
    }
    ngOnDestroy(): void {
        this.active = false;
        this.signaturePolicyDataService.clearCache();
    }
}
